module.exports = __webpack_public_path__ + "static/komodo-dc0b3da9c75a24a248bece5ed94ac30a.svg";